import { Badge } from 'primereact/badge';
import { Finding } from '@/api/domains/analyses/types';
import styles from './FindingCard.module.css';
import { getFindingTypeConfig } from '../../../utils';

interface FindingCardProps {
  finding: Finding;
  isActive: boolean;
  isViewed: boolean;
  isCollapsed: boolean;
  onClick: () => void;
}

export const FindingCard = ({
  finding,
  isActive,
  isViewed,
  onClick
}: FindingCardProps) => {
  const typeConfig = getFindingTypeConfig(finding.finding_type);

  return (
    <div
      className={`
        ${styles.card}
        ${isActive ? styles.cardActive : ''}
        ${!isViewed ? styles.cardUnviewed : ''}
      `}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      <div
        className={styles.typeIcon}
        style={{
          background: isActive
            ? 'var(--color-accent)'
            : 'rgba(55, 125, 255, 0.1)'
        }}
      >
        <i
          className={`pi ${typeConfig.icon}`}
          style={{
            fontSize: '1rem',
            color: isActive ? '#fff' : 'var(--color-accent)'
          }}
        />
      </div>

      <div className={styles.content}>
        <div className={styles.headerRow}>
          <span className={styles.typeLabel}>{typeConfig.label}</span>
          {!isViewed && (
            <div className={styles.unviewedDot} title="Not yet reviewed" />
          )}
        </div>

        <div className={styles.severityBadge}>
          <Badge
            value={finding.severity}
            severity={
              finding.severity === 'CRITICAL'
                ? 'danger'
                : finding.severity === 'HIGH'
                  ? 'warning'
                  : finding.severity === 'MEDIUM'
                    ? 'info'
                    : 'success'
            }
            style={{
              fontSize: '0.7rem',
              fontWeight: 600
            }}
          />
        </div>
      </div>

      {isActive && <div className={styles.activeIndicator} />}
    </div>
  );
};
